import { useCallback, useMemo, useState } from 'react';

interface CalendarHeaderItemHookProps {
  month: Date;
}
export const useCalendarHeaderItem = ({
  month,
}: CalendarHeaderItemHookProps) => {
  const [selectMonth, setSelectMonth] = useState(
    month instanceof Date && !isNaN(month.getTime()) ? month : new Date(),
  );

  const handleClickNextMonth = useCallback(() => {
    setSelectMonth((prev) => {
      const offset = 1;
      const updateMonth = new Date(prev);
      updateMonth.setMonth(prev.getMonth() + offset);
      return updateMonth;
    });
  }, [setSelectMonth]);

  const handleClickPrevMonth = useCallback(() => {
    setSelectMonth((prev) => {
      const offset = 1;
      const updateMonth = new Date(prev);
      updateMonth.setMonth(prev.getMonth() - offset);
      return updateMonth;
    });
  }, [setSelectMonth]);

  const calendarHeaderItem = useMemo(() => {
    const offset = 1;
    const year = selectMonth.getFullYear();
    const month = selectMonth.getMonth() + offset;
    const monthLabel = `${year}年${month}月`;
    return {
      label: monthLabel,
      onPrev: () => handleClickPrevMonth(),
      onNext: () => handleClickNextMonth(),
    };
  }, [selectMonth, handleClickPrevMonth, handleClickNextMonth]);

  return { selectMonth, calendarHeaderItem };
};
